import { Handshake } from "@mui/icons-material";
import { Stack, Tooltip, Typography } from "@mui/material";
import { Link } from "react-router-dom";

interface HeaderContractLinkBadgeProps {
  to?: string;
  tooltip: string;
  label: string;
}

export function HeaderContractLinkBadge({
  to = "/clinic#signature",
  tooltip,
  label,
}: HeaderContractLinkBadgeProps) {
  return (
    <Link to={to} style={{ textDecoration: "none" }}>
      <Tooltip title={tooltip}>
        <Stack
          direction="row"
          alignItems="center"
          border="1px solid"
          borderColor="neutral0.main"
          padding={1}
          borderRadius={2}
          spacing={1}
          sx={{
            "&:hover": {
              cursor: "pointer",
            },
          }}
        >
          <Handshake sx={{ color: "neutral0.main" }} />
          <Typography
            variant="body1"
            fontWeight={600}
            textTransform="uppercase"
            sx={{
              color: "neutral0.main",
              textShadow: "1px 1px 1px black",
            }}
          >
            {label}
          </Typography>
        </Stack>
      </Tooltip>
    </Link>
  );
}
